import React, { useState, useEffect } from 'react';
import './ComponentForm.css';

const ComponentForm = ({
  component,
  manufacturers,
  categories,
  subcategories,
  onSave,
  onCancel,
  onCategoryChange
}) => {
  const [formData, setFormData] = useState({
    component_name: '',
    manufacturer_id: '',
    component_category_id: '',
    component_subcategory_id: '',
    component_description: '',
    component_specifications: ''
  });

  useEffect(() => {
    if (component) {
      setFormData({
        component_name: component.component_name || '',
        manufacturer_id: component.manufacturer_id || '',
        component_category_id: component.component_category_id || '',
        component_subcategory_id: component.component_subcategory_id || '',
        component_description: component.component_description || '',
        component_specifications: component.component_specifications
          ? JSON.stringify(component.component_specifications, null, 2)
          : ''
      });
    } else {
      setFormData({
        component_name: '',
        manufacturer_id: manufacturers[0]?.manufacturer_id || '',
        component_category_id: categories[0]?.component_category_id || '',
        component_subcategory_id: '',
        component_description: '',
        component_specifications: ''
      });
    }
  }, [component, manufacturers, categories]);

  // When category changes, reset subcategory
  useEffect(() => {
    if (formData.component_category_id && onCategoryChange) {
      onCategoryChange(formData.component_category_id);
      if (!component) {
      setFormData(f => ({
        ...f,
        component_subcategory_id: ''
      }));
    }
    }
    // eslint-disable-next-line
  }, [formData.component_category_id]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    let specs = formData.component_specifications;
    try {
      specs = specs ? JSON.parse(specs) : null;
    } catch {
      alert('Specifications must be valid JSON');
      return;
    }
    onSave({
      ...formData,
      component_specifications: specs
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form">
      <label>
        Name:
        <input
          name="component_name"
          value={formData.component_name}
          onChange={handleChange}
          required
        />
      </label>
      <label>
        Manufacturer:
        <select
          name="manufacturer_id"
          value={formData.manufacturer_id}
          onChange={handleChange}
          required
        >
          {manufacturers.map(m => (
            <option key={m.manufacturer_id} value={m.manufacturer_id}>
              {m.manufacturer_name}
            </option>
          ))}
        </select>
      </label>
      <label>
        Category:
        <select
          name="component_category_id"
          value={formData.component_category_id}
          onChange={handleChange}
          required
        >
          {categories.map(c => (
            <option key={c.component_category_id} value={c.component_category_id}>
              {c.category_name}
            </option>
          ))}
        </select>
      </label>
      <label>
        Subcategory:
        <select
          name="component_subcategory_id"
          value={formData.component_subcategory_id}
          onChange={handleChange}
          required
        >
          <option value="">Select Subcategory</option>
          {subcategories.map(s => (
            <option key={s.component_subcategory_id} value={s.component_subcategory_id}>
              {s.subcategory_name}
            </option>
          ))}
        </select>
      </label>
      <label>
        Description:
        <input
          name="component_description"
          value={formData.component_description}
          onChange={handleChange}
        />
      </label>
      <label>
        Specifications (JSON):
        <textarea
          name="component_specifications"
          value={formData.component_specifications}
          onChange={handleChange}
          rows={4}
        />
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </form>
  );
};

export default ComponentForm;